import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import ExpandedRate from '@/components/app/product/components/release-details/expanded-rate';
import Props from '@/components/app/product/components/release-details/type';
import { formatDate } from '@/components/shared/helpers';

import localization, { pageLevelLocalization } from '@/constant/localization';

const { product: productLocalization } = pageLevelLocalization;

export default function ReleaseDetails({ releaseDate, version, updateDate, rate }: Props) {
  const options: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  };
  return (
    <Container>
      {releaseDate && (
        <Container center className='my-3 justify-between'>
          <Text className='text-[15px] text-[#76767C]'>{productLocalization.releaseDate}</Text>
          <Text className='text-[15px] text-[#5B5C60]'>
            {formatDate(releaseDate, 'fa-IR', options)}
          </Text>
        </Container>
      )}
      {version && (
        <Container center className='my-3 justify-between'>
          <Text className='text-[15px] text-[#76767C]'>{productLocalization.version}</Text>
          <Text className='text-[15px] text-[#5B5C60]'>{version}</Text>
        </Container>
      )}
      {updateDate && (
        <Container center className='my-3 justify-between'>
          <Text className='text-[15px] text-[#76767C]'>{productLocalization.updateDate}</Text>
          <Text className='text-[15px] text-[#5B5C60]'>
            {formatDate(updateDate, 'fa-IR', options)}
          </Text>
        </Container>
      )}
      {rate && (
        <Container center className='my-3 justify-between'>
          <Text className='text-[15px] text-[#76767C]'>{localization.rate}</Text>
          <ExpandedRate value={rate.rateAverage} />
        </Container>
      )}
    </Container>
  );
}
